module.exports = __webpack_public_path__ + "static/media/11.ddcff0b1.jpg";